import { atom } from 'jotai';

import { giveawayPickerSteps } from '@/lib/giveawayPicker/steps';

export const currentStepAtom = atom(1);

export const nextStepAtom = atom(null, (get, set) => {
    const currentStep = get(currentStepAtom);
    if (currentStep < giveawayPickerSteps.length) {
        set(currentStepAtom, currentStep + 1);
    }
});

export const previousStepAtom = atom(null, (get, set) => {
    const currentStep = get(currentStepAtom);
    if (currentStep > 1) {
        set(currentStepAtom, currentStep - 1);
    }
});
